import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SegovPage } from 'src/app/app.routes';
import { ControlsModule } from "segov-sigepo-lib";
import { ComunicadoOutputDto } from 'src/app/domain/DTOs/output/comunicado.output.dto';
import { ListarComunicadosInputDto } from 'src/app/domain/DTOs/input/listar-comunicados.input.dto';
import { filter, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { ListarComunicadosState } from 'src/app/stateManagement/reducers/listar-comunicados.reducer';
import { selectDadosListarComunicados } from 'src/app/stateManagement/selectors/listar-comunicados.selector';
import { listarComunicados, listarComunicadosFinish } from 'src/app/stateManagement/actions/listar-comunicados.action';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-card-comunicados',
  standalone: true,
  imports: [
    ControlsModule
  ],
  templateUrl: './card-comunicados.component.html',
  styleUrl: './card-comunicados.component.css'
})
export class CardComunicadosComponent implements OnInit, OnDestroy {
  public ComunicadoOutputDto: ComunicadoOutputDto | undefined;
  public DataFormatada = '';
  private subListarComunicados: Subscription;

  constructor(
    private router: Router,
    private readonly storeListarComunicados: Store<{ listarComunicadosState: ListarComunicadosState }>
  ){
    this.subListarComunicados = new Subscription();

  }

  public goToComunicados(){
    this.router.navigate([SegovPage.Comunicados]);
  }

  ngOnInit(): void {
    this.subListarComunicados = this.storeListarComunicados.select(selectDadosListarComunicados)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        if(response?.dados && response?.dados?.length > 0)
        this.ComunicadoOutputDto = response?.dados[0];
        this.DataFormatada = DateTime.fromISO(this.ComunicadoOutputDto?.dataPublicacao??"").toLocaleString()
      });

    this.getListarComunidados();
  }

  ngOnDestroy(): void {
    this.subListarComunicados.unsubscribe();
    this.storeListarComunicados.dispatch(listarComunicadosFinish());
  }

  private getListarComunidados() {
    this.storeListarComunicados.dispatch(listarComunicados({ listarComunicadosInputDto: new ListarComunicadosInputDto('', 1, 1) }))
  }
}
